import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import { config } from "../_helpers/global";

export class ConfirmStaffMember extends Component {
  constructor(props) {
    super(props);

   
    const url = "";

    this.state = { verified: "" };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    //
    console.log(localStorage.getItem("accessToken"));
    axios
      .get(this.api_url+"chief/verify", { headers: headers })
      .then((res) => {
        const verified = res.data;

        for (const key in verified) {
          var option = "<option value=" + key + ">" + key + "</option>";
          $(".confirm_card").append(option);
        }

        //   this.setState({ verified });
      });
  }

  handleChange(event) {
    this.setState({
      verified: event.target.value,
    });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    let self = this;
    event.preventDefault();
    console.log(this.state);
    axios
      .post(this.api_url+"chief/verify", this.state, {
        headers: headers,
      })
      .then((response) => {
        console.log(response.data["status"]);
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/confirm/staff/member";
            // this.props.history.push('/reception/dashboard')
          }, 1000);
          // this.props.history.push('/reception/dashboard')
        } else {
          $("#loginError").fadeIn();
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    let forgotPasswordUrl = "/forgot/password";

 

    const { verified } = this.state;

    return (
      <div>
        <Headers></Headers>
        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1"></div>

                <div className="col-md-4 p-2">
                  <h2 className="center text-capitalize">
                    Confirm Staff Members
                  </h2>
                  <div className="card pt-5 pr-5 pl-5 ">
                    <div className="py-1">
                      <h6 className="text-capitalize" style={fontFamilyNunito}>
                        Staff Members
                      </h6>
                      <select
                        className="form-control"
                        onChange={this.handleChange}
                        value={verified}
                        name="verified"
                        required
                      >
                        <optgroup
                          label="Staff Members"
                          className="confirm_card"
                        >
                          <option selected disabled></option>
                        </optgroup>
                      </select>
                    </div>

                    <div
                      id="loginSuccess"
                      className="alert alert-success"
                      style={displayHidden}
                      role="alert"
                    >
                      <strong>Success! </strong>Approval Successful.
                    </div>
                    {/* <p className="loginSuccess lead" >Login Successful</p> */}
                    <button
                      className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                      type="submit"
                      style={floatLeft}
                    >
                      Approve
                    </button>

                    {/* <button type="submit" style={floatLeft}> */}

                    {/* </button> */}

                    <div style={displayHidden} className="col col-6">
                      <button
                        className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold"
                        type="button"
                        style={floatRight}
                      >
                        Send To Triage
                      </button>
                    </div>
                    {/* <div className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold" type="submit" style={floatLeft}>Submit</button></div> */}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ConfirmStaffMember;
